import * as React from 'react';

import {ActionBox} from 'shells/action-box/action-box';
import {ErrorIcon} from 'shells/action-box/action-icons';
import {Button} from 'shells/button/button';

type Props = {
    editionsMissingDelays: string[];
    closeModal: () => void;
    scrollToEdition: (arg1: string) => void;
};

export function DelayActionBox(props: Props) {
    const {editionsMissingDelays} = props;

    return (
        <ActionBox
            title='Delays'
            subtitle={getDelayText(editionsMissingDelays)}
            icon={<ErrorIcon />}
            actionElement={getDelayActionElement(
                editionsMissingDelays,
                props.closeModal,
                props.scrollToEdition
            )}
        />
    );
}

function getDelayText(editionsMissingDelays?: string[] | null) {
    return editionsMissingDelays && editionsMissingDelays.length === 1
        ? 'One of your messages is missing a delay'
        : 'Some of your messages are missing a delay';
}

function getDelayActionElement(
    editionsMissingDelays: string[] | null | undefined,
    closeModal: () => void,
    scrollToEdition: (arg1: string) => void
) {
    const firstEditionWithError =
        editionsMissingDelays && editionsMissingDelays.length
            ? editionsMissingDelays[0]
            : undefined;

    const onClose = () => {
        closeModal();
        if (firstEditionWithError) {
            scrollToEdition(firstEditionWithError);
        }
    };

    return editionsMissingDelays && editionsMissingDelays.length === 1 ? (
        <Button variant='text-primary' size='big' onClick={onClose}>
            Update delay
        </Button>
    ) : (
        <Button variant='text-primary' size='big' onClick={onClose}>
            Update delays
        </Button>
    );
}
